var Eventable = require('./../../lib/Eventable');

var eventable = new Eventable();
var name = 'whatever';

module.exports = {
    register: function (callback) {
        eventable.addEventListener(name, callback);
    },
    unregister: function (callback) {
        eventable.removeEventListener(name, callback);
    },
    dispatch: function (action) {
        eventable.triggerEvent(name, action);
    }
};
